import { ref } from 'vue';

/* Подтверждение действия — своим диалогом, а не window.confirm.

   Системный confirm на цеховом планшете — это чужое окно мелким шрифтом,
   с кнопками на языке устройства, поверх экрана, рассчитанного на крупные
   касания в перчатках. У него нет ни названия действия, ни объяснения
   последствий: только вопрос и «ОК». Там, где подтверждают решение,
   уходящее наружу — сертификат заказчику, навеска вне рецепта, — этого мало.

   Обещание вместо колбэка выбрано ради места вызова: `if (!await
   подтвердить(...)) return;` читается ровно как прежняя строка с confirm,
   и четыре функции не пришлось выворачивать наизнанку.

   Состояние живёт в модуле, а рисует его один ConfirmHost в App.vue.
   Диалог в системе один и тот же на всех экранах: заводить его копию
   в каждом значит однажды получить четыре разных подтверждения. */

const пусто = () => ({
  open: false,
  title: '',
  text: '',
  detail: '',
  confirmLabel: 'Подтвердить',
  cancelLabel: 'Отмена',
  danger: false,
});

export const запрос = ref(пусто());

let решить = null;

/* Возвращает обещание: true — подтвердил, false — отказался или закрыл.

   Второй вызов, пока открыт первый, закрывает первый отказом. Такое бывает
   при быстрых нажатиях, и молча потерянное обещание оставило бы вызвавшую
   функцию висеть навсегда. */
export function подтвердить(опции = {}) {
  if (решить) { решить(false); решить = null; }

  запрос.value = {
    ...пусто(),
    ...(typeof опции === 'string' ? { text: опции } : опции),
    open: true,
  };

  return new Promise((resolve) => { решить = resolve; });
}

export function ответить(да) {
  запрос.value = { ...запрос.value, open: false };
  const r = решить;
  решить = null;
  if (r) r(!!да);
}
